'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTracker = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _PublicTrackingClient = require('./PublicTrackingClient');

var _PublicTrackingClient2 = _interopRequireDefault(_PublicTrackingClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTracker = exports.createTracker = function createTracker() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /*
   * Public trackers are intended to be used on
   * externally hosted domains (non-hubspot controlled).
   *
   * Anonymous no-auth visitors on these domains should be
   * marked with a unique TEMP_ID user identifier so that
   * we do not sync their data with contact data in 53.
   */
  if (opts && (typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) === 'object' && typeof opts.isExternalHost === 'undefined') {
    opts.isExternalHost = true;
  }

  return _PublicTrackingClient2.default.createTracker(opts);
};